const serverError =
  'Ocorreu um erro nos nossos servidores. Estes podem estar temporariamente indisponíveis ou em manutenção. Por favor, tente novamente mais tarde.'

export default { serverError }
